export default __webpack_public_path__ + "static/media/Grips of the Membranous.459c6a23.jpg";